import { FC } from "react";
import * as Highcharts from 'highcharts/highmaps';
import HighchartsReact from 'highcharts-react-official';
import mapDataWorld from '@highcharts/map-collection/custom/world.geo.json';
import { arrayConversion } from "./const";


const HighchartsMapComponent: FC<HighchartsReact.Props> = (props: HighchartsReact.Props): JSX.Element => {

  const options: Highcharts.Options = {
    chart: {
      map: mapDataWorld,
    },
    colorAxis: {
      min: 60
    },
    tooltip: {
      valueDecimals: 1,
      valueSuffix: ' years'
    },
    series: [{
      type: 'map',
      mapData: mapDataWorld,
      data: arrayConversion(),
      dataLabels: {
        enabled: true,
        color: '#00000',
        format: '{point.code}'
      },
      name: 'Case Volume',
      tooltip: { pointFormat: 'Cases: {point.value}' },
      animation: true,
    }]
  }

  return (
    <div id='mapChart'>
      <HighchartsReact
        options={options}
        highcharts={Highcharts}
        constructorType={'mapChart'}
        {...props}
      />
    </div>
  );
}

export default HighchartsMapComponent;
